import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const getPlaceholderEventValues = (eventId) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.ENGAGEMENT_CENTER.GET_PLACEHOLDER_EVENT_VALUES(eventId)
  );
};

export default getPlaceholderEventValues;
